import { render } from "./CardTitle.vue?vue&type=template&id=40599266&ts=true"
import script from "./CardTitle.vue?vue&type=script&lang=ts"
export * from "./CardTitle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__